import React from 'react';
import { DynamicHeroBuilder } from '../../builder/components/hero/DynamicHero.builder';
import { FALLBACK_HERO, FALLBACK_HERO_IMAGES, FALLBACK_HERO_ASSETS } from '../../utils/constants';

function FallbackHero({ heroConfig = {}, imageAltType = 'googleSocial' }) {
  const {
    description = FALLBACK_HERO.description,
    buttonText = FALLBACK_HERO.buttonText,
    buttonLink = FALLBACK_HERO.buttonLink,
    graphic = {
      src: FALLBACK_HERO_ASSETS.BADGE,
      alt: FALLBACK_HERO.graphic.alt
    },
    footerText = FALLBACK_HERO.footerText
  } = heroConfig;

  const richTextContent = `<p>${description}</p>`;

  const heroProps = {
    heroDesktopImage: FALLBACK_HERO_ASSETS.HERO_DESKTOP,
    heroTabletImage: FALLBACK_HERO_ASSETS.HERO_TABLET,
    heroMobileImage: FALLBACK_HERO_ASSETS.HERO_MOBILE,
    heroMobileImageAlt: FALLBACK_HERO_IMAGES.altTexts[imageAltType],
    typefaceLogo: graphic.src,
    logoImageAlt: graphic.alt,
    heading: FALLBACK_HERO.heading,
    richTextContent,
    buttonLabel: buttonText,
    buttonLink,
    footerText,
    isHeroImgOnRight: false,
  };

  return (
    <section className="hero py-0">
      <DynamicHeroBuilder {...heroProps} />
    </section>
  );
}

export default FallbackHero;